import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_SHARE_ON_COMBO_EXPERIMENT = defineFcm('promote_share_on_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'psf combo page',
		description: 'Promote share on combo experiment',
		import: false,
		template: {
			enabled: false,
			experimentName: 'promote_share_on_combo',
		},
	});
